/* Fairy Peony – switch the product photo when a color is picked.
   For colors that have no photo linked in Shopify admin, this finds the first
   product photo whose alt text names that color (e.g. "... in khaki, front view")
   and gives it to the variant, so the theme's own gallery switch works.
   Colors that already have a linked photo in admin are left untouched. */
(function () {
  if (window.__fpVariantPhotos) return;
  window.__fpVariantPhotos = true;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/grey/g, 'gray').replace(/\s+/g, ' ').trim();
  }
  function esc(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  function findMedia(media, value) {
    var v = norm(value);
    if (!v) return null;
    var exact = new RegExp('(^|[^a-z0-9-])(in|color) ' + esc(v) + '(?![a-z0-9-])');
    var loose = new RegExp('(^|[^a-z0-9-])' + esc(v) + '(?![a-z0-9-])');
    var fallback = null;
    for (var i = 0; i < media.length; i++) {
      var alt = norm(media[i].alt);
      if (exact.test(alt)) return media[i];
      if (!fallback && loose.test(alt)) fallback = media[i];
    }
    return fallback;
  }
  function patch(el) {
    if (el.__fpDone || typeof el.getVariantData !== 'function') return;
    el.__fpDone = true;
    var url = (el.dataset.url || '').split('?')[0];
    if (!url) return;
    fetch(url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.media) return;
        var media = p.media.filter(function (m) { return m.media_type === 'image'; });
        var idx = 0;
        (p.options || []).forEach(function (o, i) {
          if (/colou?r/i.test(o && o.name ? o.name : o)) idx = i;
        });
        var changed = false;
        el.getVariantData().forEach(function (v) {
          if (v.featured_media) return;
          var m = findMedia(media, (v.options || [])[idx]);
          if (!m) return;
          var src = m.src || (m.preview_image && m.preview_image.src);
          v.featured_media = { id: m.id, alt: m.alt, position: m.position, preview_image: m.preview_image };
          v.featured_image = { id: m.id, src: src, alt: m.alt, position: m.position };
          changed = true;
        });
        if (changed && el.currentVariant && el.currentVariant.featured_media) {
          el.updateMedia(300, 'change');
        }
      })
      .catch(function () {});
  }
  function run() {
    document.querySelectorAll('variant-radios, variant-selects').forEach(patch);
  }
  function go() {
    run();
    ['variant-radios', 'variant-selects'].forEach(function (n) {
      if (window.customElements) customElements.whenDefined(n).then(run);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
